import basic_date_table_vue_vue_type_script_setup_true_lang_default from "./basic-date-table.vue_vue_type_script_setup_true_lang.mjs";

//#region ../../packages/components/date-picker-panel/src/date-picker-com/basic-date-table.vue
var basic_date_table_default = basic_date_table_vue_vue_type_script_setup_true_lang_default;

//#endregion
export { basic_date_table_default as default };
//# sourceMappingURL=basic-date-table.mjs.map